module.exports = __webpack_public_path__ + "static/alkilith-2b7e265bb1fbf61fa1f30c8c4dcfb86a.png";